import React from 'react';
import { Tile, TileContent, Typography } from '@one-thd/sui-atomic-components';

interface CardMethodProps {
  onClick: () => void;
  selected: boolean;
  header: string;
  children: React.ReactNode;
}

const CardMethod = ({
  onClick,
  selected,
  header,
  children,
}: CardMethodProps) => {
  const returnCost = 'FREE';
  return (
    <div className="sui-flex sui-w-full sui-gap-4">
      <Tile onClick={onClick} selected={selected} grow>
        <TileContent>
          <div className="sui-flex sui-flex-col sui-w-full sui-px-2 sui-pt-2 sui-pb-1">
            <div className="sui-flex sui-justify-between sui-mb-1">
              <h5 className="sui-h5-bold sui-line-clamp-3 sui-font-normal sui-text-primary">
                {header}
              </h5>
              <Typography
                weight="bold"
                color={returnCost === 'FREE' ? 'success' : 'primary'}
              >
                {returnCost}
              </Typography>
            </div>
            <Typography>{children}</Typography>
          </div>
        </TileContent>
      </Tile>
    </div>
  );
};

export default CardMethod;
